var KeyType;
(function (KeyType) {
  KeyType["ESCAPE"] = "Escape";
  KeyType["SPACE"] = " ";
  KeyType["ENTER"] = "Enter";
})(KeyType || (KeyType = {}));

export { KeyType as K };

